import { render, staticRenderFns } from "./splitLine.vue?vue&type=template&id=5f38962d&scoped=true"
import script from "./splitLine.vue?vue&type=script&lang=js"
export * from "./splitLine.vue?vue&type=script&lang=js"
import style0 from "./splitLine.vue?vue&type=style&index=0&id=5f38962d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f38962d",
  null
  
)

export default component.exports